import ApiClient from './client';
const client = new ApiClient();

export default {
    list(paginationInfo) {
        return client.post('api/menu/CategoriesListPaginated', paginationInfo, {
            'Content-Type': 'application/json'
        });
    },

    listNoPagination() {
        return client.get('api/menu/ListCategories', {
            'Content-Type': 'application/json'
        });
    },

    create(name) {
        return client.post('api/menu/CategoryAdd', {
            'name': name
        }, {
            'Content-Type': 'application/json'
        });
    },

    update(id, name) {
        return client.post('api/menu/CategoryUpdate', {
            'id': id,
            'name': name
        }, {
            'Content-Type': 'application/json'
        });
    },

    delete(id) {
        return client.delete('api/menu/categorydelete/' + id, {
            'Content-Type': 'application/json'
        });
    }
}   